<template>
  <el-container>
    <div style="width: 100%">
      <div class="d">
        <div class="order_title">订单基本信息</div>
        <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" class="form">
          <el-row>
            <el-col :span="12">
              <el-form-item label="订单编号:" size="small" style="width: 70%">
                <el-input v-model="formData.orderNo" :disabled="true" size="small"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="订单总额:" size="small" style="width: 70%">
                <el-input v-model="formData.amount" @blur="updateAmount()" :disabled="formData.paymentStatus != 0" ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="用户名:" size="small" style="width: 70%">
                <el-input v-model="formData.userName" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="支付状态:" size="small" style="width: 70%" >
                <el-select v-model="formData.paymentStatus" placeholder="支付状态">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="已支付" :value="1"></el-option>
                  <el-option label="未支付" :value="0"></el-option>
                  <el-option label="支付中" :value="2"></el-option>
                  <el-option label="支付失败" :value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否需要发票:" size="small" style="width: 70%">
                <el-select v-model="formData.isBill" placeholder="是否需要开发票"  :disabled="true" >
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="是否已经开票:" size="small" style="width: 70%">
                <el-select v-model="formData.isdrawBill" placeholder="是否已开发票" :disabled="true">
                  <el-option label="全部" value=""></el-option>
                  <el-option label="是" :value="1"></el-option>
                  <el-option label="否" :value="0"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="收货人:" size="small" style="width: 70%">
                <el-input v-model="formData.receiver" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="联系方式:" size="small" style="width: 70%">
                <el-input v-model="formData.telNum" :disabled="true"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="支付方式:" size="small" style="width: 70%">
                <el-select v-model="formData.payType" placeholder="支付方式" size="small" :disabled="true">
                  <el-option label="无" :value="0"></el-option>
                  <el-option label="易宝支付" :value="1"></el-option>
                  <el-option label="校园支付" :value="2"></el-option>
                  <el-option label="汇款支付" :value="3"></el-option>
                  <el-option label="现场支付" :value="4"></el-option>
                  <el-option label="微信支付" :value="5"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <tmplate v-if="formData.payType == 3">
            <el-row >
              <el-col :span="12">
                <el-form-item label="汇款人姓名:" size="small" style="width: 70%">
                  <el-input v-model="formData.remittance" :disabled="true"></el-input>
                </el-form-item>
              </el-col>
            </el-row >
            <el-row >
              <el-col :span="12">
                <el-form-item label="汇款截图:">
                  <el-card :body-style="{ padding: '0px'}" style="width: 70%">
                    <img :src="formData.screenshot" class="image" width="100%" @click="showScreen">
                  </el-card>
                  <el-dialog :visible.sync="dialogVisible" size="tiny">
                    <img width="100%" :src="formData.screenshot" alt="">
                  </el-dialog>
                </el-form-item>
              </el-col>
            </el-row>
          </tmplate>
        
        </el-form>
      </div>
      <div class="d" v-if="formData.isBill === 1">
        <div class="order_title">发票信息</div>
        <el-form :label-position="labelPosition" label-width="120px" :model="formLabelAlign" class="form">
          <template v-if="formData.mallPaymentInvoice.invoice  == 0">
            <el-form-item label="发票抬头:">
              <el-input value="个人" :disabled="true" v-if="formData.mallPaymentInvoice.invoice  == 0"></el-input>
            </el-form-item>
            <el-form-item label="邮寄地址:">
              <el-input v-model="formData.mallPaymentInvoice.address" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="邮编:">
              <el-input v-model="formData.mallPaymentInvoice.zipCode" :disabled="true"></el-input>
            </el-form-item>
          </template>
          
          <template v-if="formData.mallPaymentInvoice.invoice  == 1">
            <el-form-item label="发票抬头:">
              <el-input v-model="formData.mallPaymentInvoice.companyName" :disabled="true" v-if="formData.mallPaymentInvoice.invoice  == 1"></el-input>
              <el-input v-model="个人" :disabled="true" v-if="formData.mallPaymentInvoice.invoice  == 2"></el-input>
            </el-form-item>
            <el-form-item label="发票类型:">
              <el-select v-model="formData.mallPaymentInvoice.type" placeholder="发票类型" size="small" :disabled="true">
                <el-option label="增值税专用发票" :value="1"></el-option>
                <el-option label="增值税普通发票" :value="0"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="邮寄地址:">
              <el-input v-model="formData.mallPaymentInvoice.address" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="邮编:">
              <el-input v-model="formData.mallPaymentInvoice.zipCode" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="纳税人识别号:">
              <el-input v-model="formData.mallPaymentInvoice.taxpayerNumber" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="注册地址:">
              <el-input v-model="formData.mallPaymentInvoice.registeredAddress" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="注册电话:">
              <el-input v-model="formData.mallPaymentInvoice.registeredPhone" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="开户行:">
              <el-input v-model="formData.mallPaymentInvoice.bank" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="公司账号:">
              <el-input v-model="formData.mallPaymentInvoice.companyAccount" :disabled="true"></el-input>
            </el-form-item>
          </template>
        
        </el-form>
      </div>
      <div class="d">
        <div class="order_title">订单详情</div>
        <el-table
            :data="commodityList"
            border
            highlight-current-row
            :span-method="objectSpanMethod"
            style="width: 100%"
        >
          <el-table-column
              type="index"
              label="序号"
              width="50"
              fixed="left"
          >
          </el-table-column>
          <el-table-column
              prop="commodityName"
              label="商品名称"
              fixed="left"
          >
          </el-table-column>
          <el-table-column
              prop="sku"
              label="型号"
              fixed="left"
              v-if="scoreType != 2"
              :formatter="f_sku"
          >
          </el-table-column>
          <el-table-column
              prop="costPrice"
              label="原价"
              width="150"
          >
          </el-table-column>
          <el-table-column
              prop="amount"
              label="销售价格"
              width="150"
              :formatter="f_amount"
          >
          </el-table-column>
          <el-table-column
              prop="num"
              label="数量"
              width="100"
          >
          </el-table-column>
          <el-table-column
              prop="courseName"
              label="课程名称"
              width="100"
          >
          </el-table-column>
          <el-table-column
              label="操作"
              width="100"
          >
            <template slot-scope="scope">
              <el-button @click="updateCourse(scope.row)" type="text" size="small">修改课程</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-dialog
          title="选择课程"
          :visible.sync="choseCommodity"
          :close-on-click-modal=false
          :before-close="handleClose"
      >
    
        <el-form ref="searchDate" :model="searchData" label-width="80px" label-position="top" style="margin-bottom: 10px">
          <el-row >
            <!--<el-col :span="5" class="cls-col">
              <el-form-item label="所属机构" prop="orgCode">
                <el-select size="small" placeholder="所属机构" clearable v-model="searchData.orgCode" @change="changeOrg" style="width: 100%" clearable >
                  <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
                </el-select>
              </el-form-item>
            </el-col>-->
            <el-col :span="5" class="cls-col">
              <el-form-item label="所属分类" prop="selectedOption">
                <el-cascader
                    expand-trigger="hover"
                    size="small"
                    clearable
                    :options="courseOptions"
                    v-model="searchData.selectedOption"
                    style="width: 100%"
                    :props="{ value: 'courseTypeId', label: 'courseTypeName',children: 'childNodeLst'}"
                >
                </el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="5" class="cls-col">
              <el-form-item label="课程名称" prop="name">
                <el-input v-model="searchData.name" placeholder="课程名称" size="small" ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" class="cls-col">
              <el-form-item style="margin-top: 30px">
                <el-button type="primary" plain size="small" icon="el-icon-search" @click="search()">查询</el-button>
              </el-form-item>
            </el-col>
          </el-row>
    
        </el-form>
    
        <el-table
            :data="commodityData"
            ref="commodityList"
            @select="select"
            border>
          <el-table-column
              type="selection"
              width="55">
          </el-table-column>
          <el-table-column
              prop="name"
              label="课程名称">
          </el-table-column>
          <el-table-column
              prop="orgName"
              label="机构"
          >
          </el-table-column>
          <el-table-column
              prop="ccName"
              label="课程分类"
              :formatter="f_categoryName"
          >
          </el-table-column>
        </el-table>
        <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="pageSize"
            :current-page.sync="currentPage"
            @current-change="handleCurrentChange"
            style="margin-top: 5px; float: right; margin-right: 10px">
        </el-pagination>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="selectCommodity()">确 定</el-button>
        </div>
      </el-dialog>
    </div>
  </el-container>
</template>

<script>
  export default {
    name: 'orderDetail',
    data() {
      return {
        isZH: false,
        scoreType: "",
        labelPosition: 'right',
        commodity: {},
        commodityData: [],
        org: [],
        courseOptions: [],
        choseCommodity: false,
        total: 0,
        currentPage: 1,
        pageSize:10,
        searchData: {
          limit: 0,
          page: 1,
          name: '',
          ccId: '',
          categoryOne: "",
          categoryThree: "",
          categoryTwo: "",
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          courseType: '0',
          status: 2,
          orgCode: ''
        },
        formLabelAlign: {
          name: '',
          region: '',
          type: ''
        },
        formData: {},
        commodityList: [],
        obj: {},
        initPos: '',
        dialogVisible: false
      };
    },
    methods: {
      handleClose() {
        this.choseCommodity = false;
        this.searchData.selectedOption=[];
        this.searchData.name = "";
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if(this.isZH) {
          if(this.scoreType != 2) {
            if(columnIndex == 4) {
              if(rowIndex == 0) {
                return {
                  rowspan: this.commodityList.length,
                  colspan: 1
                };
              } else {
                return {
                  rowspan: 0,
                  colspan: 0
                };
              }
            }
          } else {
            if(columnIndex == 3) {
              if(rowIndex == 0) {
                return {
                  rowspan: this.commodityList.length,
                  colspan: 1
                };
              } else {
                return {
                  rowspan: 0,
                  colspan: 0
                };
              }
              
            }
          }
        }
      },
      select(selection, row) {
        if (selection.length > 1) {
          let del_row = selection.shift()
          this.$refs.commodityList.toggleRowSelection(del_row, false)
        }
        this.changeCommodity = row;
      },
      showScreen() {
        this.dialogVisible = true;
      },
      handleCurrentChange(val) {
        this.search(val);
      },
      f_org(row, column, cellValue, index) {
        for(let o of this.org) {
          if(o.orgCode == cellValue) {
            return o.organizationName;
          }
        }
      },
      f_amount(row, column, cellValue, index) {
        if(this.isZH) {
          return this.formData.amount;
        }
        return cellValue;
      },
      f_categoryName(row, column, cellValue, index) {
        let categoryName = "";
        if(row.categoryOneName) {
          categoryName += row.categoryOneName;
        }
        if(row.categoryTowName) {
          categoryName += "/"+row.categoryTowName;
        }
        if(row.categoryThreeName) {
          categoryName += "/"+row.categoryThreeName;
        }
        return categoryName
      },
      f_sku(row, column, cellValue, index) {
        if(cellValue) {
          return cellValue
        } else {
          return "无"
        }
      },
      updateCourse(item) {
        this.commodity = item;
        this.search();
        this.searchCourseType();
        this.choseCommodity = true;

      },
      selectCommodity() {
        // /mallOrderInfo/changeCourse
        let courseId = this.changeCommodity.courseId;
        let params = {
          id: this.commodity.id,
          courseId: courseId,
        };
        this.https.fetchPost('/mallOrderInfo/changeCourse',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.$message({
              type: 'success',
              message: "课程更改成功"
            });
            this.commodity.courseName = this.changeCommodity.name
            this.choseCommodity = false;
            this.searchData.selectedOption=[];
            this.searchData.name = "";
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },
      search(val) {
        if(this.searchData.selectedOption.length > 0) {
          this.searchData.ccId = this.searchData.selectedOption[this.searchData.selectedOption.length-1];
        } else {
          this.searchData.ccId = '';
        }
        if(val) {
          this.searchData.page = val;
        } else {
          this.searchData.page = 1;
          this.currentPage = 1;
        }
        this.searchData.limit = 10;
        let params = this.searchData;
        let selectedCourseType = this.searchData.selectedOption
        params.categoryOne = "";
        params.categoryTwo = "";
        params.categoryThree = "";
        if (selectedCourseType && selectedCourseType.length > 0) {


          switch (selectedCourseType.length) {
            case 1:
              params.categoryOne = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 2:
              params.categoryTwo = selectedCourseType[selectedCourseType.length - 1];
              break;
            case 3:
              params.categoryThree = selectedCourseType[selectedCourseType.length - 1];
              break;
          }
        }

        this.https.fetchPost('/course/getCourseByType',params, 'json' ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            this.commodityData = data.data.data;
            this.total = data.data.total;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err=>{
              console.log(err);
            }
        );
      },
      searchById(orderId) {
        // /mallOrderInfo/selectMallOrderInfoVoByMallOrderInfo
        let params = {
          orderId: orderId,
        }
        this.https.fetchPost('/mallOrderInfo/detail',params,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.formData = data.data.data;
            this.formData.passportName = this.formData.passportFirstName=null?'':this.formData.passportFirstName+ " "+ this.formData.passportLastName?'':this.formData.passportLastName;
            this.searchData.orgCode = this.formData.org;
            this.commodityList = data.data.data.snapshotVos;
            for(let commodity of data.data.data.snapshotVos) {
              this.scoreType = commodity.type;
              if(commodity.type == 4) {
                this.isZH = true;
              }
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
          }
        }).catch(err=>{
              console.log(err)
              this.$message.error('数据加载失败');
            }
        )
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
            }
        );
      },
      changeOrg() {
        this.searchCourseType();
      },
      searchCourseType() {
        if(!this.searchData.orgCode) {
          return;
        }
        let params = {
          orgCode: this.searchData.orgCode
        };
        this.https.fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseOptions = data.data.data.childNodeLst;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      updateAmount() {
        let params = {
          orderId: this.formData.orderId,
          amount: this.formData.amount,
        };
        
        this.https.fetchPost('/mallOrderInfo/pricing',params ,"json" ).then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == '200') {
            this.$message({
              type: 'success',
              message: '修改成功!'
            });
          } else {
            this.$message({
              type: 'info',
              message: msg
            })
            this.formData.amount = this.oldAmount;
          }
        }).catch(err=>{
              this.$message.error('数据加载失败');
            }
        )


      },
    },
    created: function() {
      this.loginOrgCode = this.$store.state.orgCode;
      let orderId = this.$route.query.orderId;
      if (orderId) {
        this.searchById(orderId);
        this.selectOrg();
        this.searchCourseType();
      }else {
        this.$router.push({
          name: "order"
        })
        return
      }
    }
  };
</script>

<style scoped>
  
  .d {
    width: 60%;
    margin: 20px 0 0 50px;
    border-radius: 10px;
    border: 1px solid #DCDFE6;
    padding-bottom: 40px;
    display: block;
  }
  
  .order_title {
    height: 50px;
    line-height: 50px;
    font-size: 20px;
    background: #f0f0f0;
    margin-bottom: 20px;
    padding-left: 40px;
  }
  
  .form {
    border: 1px solid #DCDFE6;
    border-radius: 10px;
    padding-top: 15px;
    background: #f0f0f0;
    margin: 0 40px;
  }
</style>